module.exports = __webpack_public_path__ + "img/tokens-list.4cf1a1bc.svg";